
import MyRoyaltiesPage from './myroyaltiespage'

export default MyRoyaltiesPage;